module.exports = __webpack_public_path__ + "static/media/bg_log.94f0cf82.jpg";